import { CapacityContributionLocationType, CapacityContributionType } from '@navio/nsdk';
import { NoddiIconName } from 'noddi-ui-common';
import { GARAGE_ICON_NAME } from '../LeafLetMap/markers/facilityIcons';

export const CAPACITY_CONTRIBUTION_TYPE_ICON: Record<CapacityContributionType, NoddiIconName> = {
  [CapacityContributionType.BASELINE]: 'Layers',
  [CapacityContributionType.PERSONAL]: 'User'
};

export const CAPACITY_CONTRIBUTION_LOCATION_TYPE_ICON: Record<CapacityContributionLocationType, NoddiIconName> = {
  [CapacityContributionLocationType.MOBILE]: 'LocationEdit',
  [CapacityContributionLocationType.STATIONARY]: GARAGE_ICON_NAME
};
